import React from 'react';
import { ExtendedContentContainer } from 'components/ExtendedContent/ExtendedContentContainer';
import Whiteboard from 'components/Whiteboard';

export const WhiteboardModalComponent = () => {
    return <ExtendedContentContainer>
        <Whiteboard />
    </ExtendedContentContainer>
};
